import React from "react";
import { number, string } from "prop-types";

const DefaultDesktopLogo = ({ color = "#C6CCD5", width = 24.12, height = 23.04 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className="desktop-logo">
    <g id="Group_2549" data-name="Group 2549" transform="translate(-306.498 -684.405)">
      <path
        id="Path_69"
        d="M421.5 721.569a14.127 14.127 0 1 0-14.125-14.123 14.126 14.126 0 0 0 14.125 14.123z"
        className="cls-1"
        style={{ fill: "#ee4023" }}
        data-name="Path 69"
      />
      <g id="Group_2543" data-name="Group 2543">
        <path
          id="Rectangle_522"
          d="M0 0h1.438v7.029H0z"
          className="cls-1"
          style={{ fill: "#ee4023" }}
          data-name="Rectangle 522"
          transform="rotate(-.065 603496.097 -370560.664)"
        />
      </g>
      <g id="Group_2544" data-name="Group 2544">
        <path
          id="Rectangle_523"
          d="M0 0h7.074v1.439H0z"
          className="cls-1"
          style={{ fill: "#ee4023" }}
          data-name="Rectangle 523"
          transform="rotate(-60.954 803.45 -17.818)"
        />
      </g>
      <g id="Group_2545" data-name="Group 2545">
        <path
          id="Rectangle_524"
          d="M0 0h7.028v1.439H0z"
          className="cls-1"
          style={{ fill: "#ee4023" }}
          data-name="Rectangle 524"
          transform="rotate(-31.57 1452.087 -419.525)"
        />
      </g>
      <g id="Group_2546" data-name="Group 2546">
        <path
          id="Rectangle_525"
          d="M0 0h1.439v7.008H0z"
          className="cls-1"
          style={{ fill: "#ee4023" }}
          data-name="Rectangle 525"
          transform="rotate(-29.2 1524.403 -442.588)"
        />
      </g>
      <g id="Group_2547" data-name="Group 2547">
        <path
          id="Rectangle_526"
          d="M0 0h1.439v6.98H0z"
          className="cls-1"
          style={{ fill: "#ee4023" }}
          data-name="Rectangle 526"
          transform="rotate(-59.23 813.327 -5.226)"
        />
      </g>
      <g id="Group_2548" data-name="Group 2548">
        <path
          id="Path_70"
          d="M362.907 710.909c-11.45 7.391-15.737 9.5-15.737 9.5v7.256c14.668-6.95 23.662 1.914 23.662 1.914v2.485h6.868v-21.077a4.024 4.024 0 0 0-2.229-3.659h12.31a25.945 25.945 0 0 0-5.341 2.155 3.391 3.391 0 0 0-1.486 3.314l8.395 3.487s1.026.3 1.063 1.043c.062.88-1.068 1.153-1.068 1.153s-4.836.376-7.252 2.356c-1.74 1.433-1.335 2.672-1.335 2.672v3.6c0 .306 0 .556.16.712 1.917 1.984 5.577 2.591 5.577 2.591l2.964-1.617c-3.127-.239-3.263-.955-3.31-1.563-.024-.487.485-2.053 7.033-2.389 5.863-.3 11.629 3.907 11.629 3.907v3.288h6.858v-20.91c0-1.209-.334-6.063-6.478-6.063l-5.98-.041h-32.756v.958c4.459.451 4.372 3.475 4.372 3.475V724.2a20.131 20.131 0 0 0-11.214-4.484 43.173 43.173 0 0 0 7.278-5.171 2.3 2.3 0 0 0 .385-2.865 17.009 17.009 0 0 0-4.319-5.844c-2.921-2.606-6.681-.91-6.681-.91l-3.648 1.644c-9.359-5.247-14.917-.373-14.917-.373v1.076c-14.477-9.643-24.248 2.6-24.248 2.6V713l9.84-.025-4.045 3.859v5.423l18.2-6.771v9.281a12.226 12.226 0 0 0-8.884-1.533c-3.089.685-7.8 2.5-9.132 2.562-6.061.271-6.462-4.005-6.533-6.184-.052-1.552 1.723-1.321 1.723-1.321v-2.67h-7.9a19.557 19.557 0 0 0-.135 4.7c.674 6.548 4.426 9.126 7.67 9.835 6.257 1.37 10.549-2.53 14.711-2.9a11.283 11.283 0 0 1 8.443 3.05v1.545h6.867v-22.909a2.592 2.592 0 0 1 1.784-1.7c2.969-.541 4.2.244 4.2.244a17.266 17.266 0 0 0-2.141 1.39c-1.217.881-.766 2.717-.676 4.193s2.685 2.522 2.685 2.522l2.2-1.08c-2.015-.666-.806-1.927-.806-1.927s7.78-3.628 9.124-4.209a6.454 6.454 0 0 1 .718-.281 1.044 1.044 0 0 1 1.38.564c.31.663.787 1.842.152 2.251zm-35.34 3.174s-.517.325-.8.019c-.132-.13-.048-.377.255-.667l1.575-1.447s1.38-1.29-.544-1.385-4.849-.08-4.849-.08-.91.112-.973-.3a.555.555 0 0 1 .3-.645c.768-.5 12.307-3.139 15.5.757zm73.409 3.369s.535-1.948-3.275-3.6c-.5-.221-3.879-1.769-7.177-3.121a.828.828 0 0 1 .174-1.566c.989-.357 6.254-1.834 6.254-1.834h4.592s3.251.015 3.251 3.2l.015 12.721a19.112 19.112 0 0 0-7.83-4.136z"
          className="cls-2"
          style={{ fill: "#231f20", fillRule: "evenodd" }}
          data-name="Path 70"
        />
      </g>
      <path
        id="Path_71"
        d="M530.818 704.941H429v2.6h7.191c-7.738 2.362-6.941 6.222-6.941 6.222v6.769c.188 3.384 4.068 3 4.068 3a36.489 36.489 0 0 0 6.252-1.566 16.265 16.265 0 0 0 4.071-1.773c2.941-1.36 1.88-3.737 1.8-3.955-.641-1.576-3.1-3.614-3.1-3.614l-2.795.873.613.6c1.035.756-.879 1.791-.879 1.791l-4.464 1.412c-2.307.546-1.527-1.112-1.41-1.338.629-1.418 3.41-2.757 4.378-3.262 7.088-3.751 8.83-.657 9.644.217 5.337 5.7.225 10.143-.89 11.138a21.684 21.684 0 0 1-14.394 5.828c-6.955.081-8.569-3.273-8.569-3.273l.646-1.546-2.5-1.289L416 730.6c21.241 14.492 36.334-4.37 36.334-4.37a12.442 12.442 0 0 1 5.222 3.425v2.2h6.678v-20.739c-.048-3.071-2.08-3.577-2.08-3.577h4.527c2.4.883 2.119 3.613 2.119 3.613v20.711h6.938v-21.014c-.028-2.99-2.209-3.31-2.209-3.31h15.091c-1.276.847-2.6 1.863-5.909 4.358-3.3 2.778-2.772 5.971-2.772 5.971v6.577a4.828 4.828 0 0 0 1.694 3.205 29.817 29.817 0 0 0 9.854 5.363c5.167 1.516 7.816-1.54 7.816-1.54l2.386-2.567-2.454-1.327c-1.751 2.773-6.144-.214-6.144-.214s-2.757-1.631-3.935-2.34c-3.409-2.178-3.343-3.142-3.343-3.142l.031-7.512c.317-2.262 8.089-6.832 8.089-6.832H516.4a3.647 3.647 0 0 1 2.348 3.77v4.491c-3.31-2.556-5.843-1.032-5.843-1.032l-4.151 2.072s1.048-1.491 2.312-3.272c1.185-1.685-.461-2.217-4.025-3.861-4.6-2.12-7.452.1-7.452.1a55.186 55.186 0 0 0-5.817 3.7c-2.963 2.177-2.7 4.289-2.7 4.289v3.27c1.645 2.781 5.508 1.931 5.508 1.931l.946-1.87c-2.426-.144-1.966-1.232-1.625-1.645 0 0 9.286-5.664 10.986-6.549.253-.131.824.077.6.569-.881 1.91-4.714 6.434-4.976 7.087-1.606 4.131 1.182 5.233 1.182 5.233l11.43-5.647c2.966-1.421 3.629.735 3.629.735v11.247h6.664v-20.848a3.825 3.825 0 0 0-2.331-3.77h4.486a3.848 3.848 0 0 1 2.379 3.785v20.83h6.55V711.3c0-2.561-1.282-6.359-5.682-6.359zm-73.266 18.684a9.525 9.525 0 0 0-3.188-2.827s.963-9.453-9.241-13.259h10.384s2.012.506 2.045 3.6z"
        className="cls-2"
        style={{ fill: "#231f20", fillRule: "evenodd" }}
        data-name="Path 71"
      />
    </g>
  </svg>
);

DefaultDesktopLogo.propTypes = {
  color: string,
  width: number,
  height: number
};

export default DefaultDesktopLogo;
